export default {
    baseStyle: {
        alignItems: 'center',
        title: {
            fontFamily: 'UniversLTStd, Arial, sans-serif',
            fontSize: {base: '14px', sm: '18px'},
            color: 'black',
            textTransform: 'uppercase',
            lineHeight: {base: '18px', sm: 'unset'}
        },
        edit: {
            color: 'gray.550',
            background: 'none',
            height: '100%',
            padding: 0,
            fontSize: {base: '12px', sm: '14px'},
            fontWeight: 400,
            display: 'flex',
            alignItems: 'center',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            _hover: {
                textDecoration: 'underline',
                color: 'gray.550'
            },
            _active: {
                background: 'none'
            },
            _focus: {
                background: 'none',
                boxShadow: 'none'
            }
        },
        main: {
            alignItems: 'flex-start',
            heading: {
                gap: '5px',
                alignItems: 'flex-start',
                color: 'black',
                fontSize: '14px'
            },
            description: {
                gap: '5px',
                alignItems: 'flex-start',
                color: 'black',
                fontSize: '14px',
                marginTop: '5px'
            }
        },
        headingHeight: {
            lineHeight: '1',
            gap: '5px',
            alignItems: 'flex-start',
            color: 'black',
            fontSize: '14px',
            fontWeight: '600'
        },
        buttonSum: {
            display: {base: 'inline-flex', md: 'none'},
            fontSize: '14px',
            variant: 'unstyled',
            color: 'gray.675',
            textTransform: 'uppercase',
            textDecoration: 'underline',
            fontWeight: '400'
        },
        hidden: {
            display: {base: 'inline-flex', md: 'none'},
            alignItems: 'center'
        },
        spacing: {
            large: {
                gap: '40px'
            },
            small: {
                gap: '12px'
            }
        },
        spacingFull: {
            justifyContent: 'space-between',
            width: 'full'
        }
    }
}
